import { createContext, type ReactNode, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { MapReducer } from "../reducers/MapReducer";

const MapContext = createContext({
	state: MapReducer.getInitialState(),
	actions: MapReducer.actions,
});

export const useMapContext = () => useContext(MapContext);

export const MapProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: MapReducer.getInitialState(),
		reducers: MapReducer.caseReducers,
	});

	return (
		<MapContext.Provider value={{ state, actions }}>
			{children}
		</MapContext.Provider>
	);
};
